import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as net from "../../lib/net";
import Dt_Txt from "../../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Eko_HH extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.eka = [];
        this.state.dpo = {};
        this.state.tot = {};
        this.state.tot.antal = 0;
        this.state.tot.brutto = 0;
        this.state.tot.netto = 0;
        this.state.tot.snitt = 0;

        this.state.today = new Date();
        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.tdts = dts;
        this.state.dts = dts;
    }
    componentDidMount(){
        this.st_oms();
    }

    componentWillUnmount(){
    }

    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        css.overflow = "auto";
        return css;
    }
    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }
    st_oms() {
        var self = this;

        if(this.state.dts == this.state.tdts) {
            self.st_act();
        }
        else
        {
            self.st_hist();
        }
    }
    st_act() {
        var self = this;

        var prm = {};
        prm.req = "pos.pos_eko.st_hh";
        prm.avd = this.state.avd;
        prm.fdat = this.state.dts;
        prm.tdat = this.state.dts;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                ///alert(JSON.stringify(ret));

                var sdo = ret.rco;
                var eka = ret.rca;
                self.setState({ tot: sdo.tot, dpo: sdo.dpo, eka: eka });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    row_snitt(row) {
        var self = this;
        var snitt = 0;
        if(row.antal == 0) return 0;
        snitt = row.brutto / row.antal;
        return snitt;
    }
    st_hist() {
        var self = this;

        var prm = {};
        prm.req = "pos.pos_eko.sth_hh";
        prm.avd = this.state.avd;
        prm.fdat = this.state.dts;
        prm.tdat = this.state.dts;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                ///alert(JSON.stringify(ret));

                var sdo = ret.rco;
                var eka = ret.rca;
                self.setState({ tot: sdo.tot, dpo: sdo.dpo, eka: eka });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }

    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column">

            <div className="d-flex flex-row justify-content-between">
                <div className="">OMSATT PER TIMMA</div>
            </div>
            <div className="flex-row justify-content-between">
                <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                <div className="cdiblue" onClick={() => this.st_oms() }>UPPDATERA</div>
            </div>

             <div className="flex">
                 <div className="flex-row thead">
                        <div className="flex">Text</div>
                        <div className="w75">Antal</div>
                        <div className="w75">Netto</div>
                        <div className="w75">Brutto</div>
                    </div>
                    <div style={ this.tb_style() }>
                        { Object.values(this.state.dpo).map((dpo, dkey) =>
                            <div key={dkey}>
                                <div className="thead px-2">Avd: { dpo.avd.toswe() }</div>
                                { Object.values(dpo.grps).map((row, key) =>
                                    <div key={key} className="flex-row trow">
                                        <div className="flex">{ row.stext.toswe() }</div>
                                        <div className="w75 text-right">{ row.antal.ztrim() }</div>
                                        <div className="w75 text-right">{ row.netto.cdipris() }</div>
                                        <div className="w75 text-right">{ row.brutto.cdipris() }</div>
                                        <div className="w75 text-right hide">{ this.row_snitt(row).cdipris() }</div>
                                    </div>
                                )}
                                <div className="flex-row thead">
                                    <div className="flex">Avd Summa</div>
                                    <div className="w75 text-right">{ dpo.tot.antal.ztrim() }</div>
                                    <div className="w75 text-right">{ dpo.tot.netto.cdipris() }</div>
                                    <div className="w75 text-right">{ dpo.tot.brutto.cdipris() }</div>
                                </div>
                            </div>
                        )}
                    </div>
            </div>
            <div className="thead px-2 hide">Total:</div>
            <div className="flex-row thead">
                <div className="flex">Summa</div>
                <div className="w75 text-right">{ this.state.tot.antal.ztrim() }</div>
                <div className="w75 text-right">{ this.state.tot.netto.cdipris() }</div>
                <div className="w75 text-right">{ this.state.tot.brutto.cdipris() }</div>
            </div>
            <div className="hide">
                <div className="txt_14">Timmar : { this.state.eka.length }</div>
            </div>

         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default Eko_HH;
